/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description UserMenuContext
 */

import { createContext, useContext } from 'react'
import type { NAV_SELECTIONS } from '../../constants'

export interface UserMenuContextProperties {
  dispatchTrackUserMenuClick: (linkClicked: string) => void
  handleStayLengthChange?: (term: NAV_SELECTIONS) => void
  isCurrentSearchView?: boolean
  isLoggedIn: boolean
  toolsActivated?: boolean
}

export const UserMenuContext = createContext<UserMenuContextProperties>({
  dispatchTrackUserMenuClick: (_linkClicked: string) => {},
  isCurrentSearchView: false,
  isLoggedIn: false,
  toolsActivated: false,
})

export const useUserMenuContext = () => useContext(UserMenuContext)
